export default __webpack_public_path__ + "static/media/DiegoALaVoz.8d72f9dc.png";